import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: number): string {
    if (value < 0) {
      return `Can't format negative duration of ${value} seconds.`;
    }
    const minutes = Math.floor(value / 60);
    const seconds = value % 60;
    return this.formatWithZeros(minutes) + ':' + this.formatWithZeros(seconds);
  }

  formatWithZeros(value: number): string {
    return value < 10 ? ('00' + value).slice(-2) : value.toString();
  }

}
